import styled from 'styled-components';

export const TeamWrapper = styled.section`
	color: #fff;

	@media screen and (max-width: 640px) {
		background-color: #403d3d;
		border-radius: 20px;
	}
`;

export const TeamProfiles = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-wrap: wrap;
	margin: 80px auto 50px;

	@media screen and (min-width: 768px) {
		width: 85%;
		margin: 100px auto;
	}
`;

export const TeamMemberWrapper = styled.div`
	margin-bottom: 4em;
	border-radius: 5px 5px 0 0;

	@media screen and (min-width: 640px) {
		&:nth-of-type(odd) img {
			border-radius: 5px 0 0 5px;
		}

		&:nth-last-child(-n + 2) {
			margin-bottom: 0;
		}
	}

	@media screen and (max-width: 650px) {
		&:last-child {
			margin-bottom: 0;
		}
	}

	@media screen and (min-width: 640px) {
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-basis: 50%;
	}
`;

export const TeamMemberDetails = styled.div`
	background-color: #484646;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: 20px;
	border-radius: 0 0 5px 5px;

	@media screen and (min-width: 640px) {
		height: 290px;
		border-radius: 0 5px 5px 0;
	}
`;

export const TeamMemberPhoto = styled.img`
	width: 100%;
	max-width: 100%;
	height: 290px;
	object-fit: cover;
	filter: saturate(0.4);
	border-radius: 5px 5px 0 0;
	transition: filter 300ms ease-in-out;

	&:hover {
		filter: none;
	}

	@media screen and (min-width: 640px) {
		border-radius: 0;
		max-width: 290px;
	}
`;

export const TeamMemberName = styled.p`
	padding-bottom: 5px;
`;

export const TeamMemberDetail = styled.small`
	line-height: 1.5;
	display: block;
`;

export const TeamMemberComment = styled.small`
	line-height: 1.5;
	display: block;

	@media screen and (max-width: 650px) {
		padding-top: 20px;
	}
`;
